import React, { Component } from "react";

class ErrBoundy extends Component {
    constructor (props) {
        super(props);
        this.state = {
            hasErr : false 
        }

    }

    componentDidCatch(err, info) {
        this.setState({hasErr : true})
    }

    render() {
        return this.state.hasErr ? <h1>ooops. this is not good</h1> : this.props.children

    }
}

export default ErrBoundy;
